import { createFileRoute, redirect } from '@tanstack/react-router';
import { AuthRequiredError, unwrap } from '@truecare/api-client';
import { api } from '../api';

/**
 * Root redirect: signed-in users go to /me; signed-out to /sign-in.
 *
 * Done via beforeLoad (not a client-side useEffect) so there's no flash
 * of the wrong UI — the redirect happens before any component renders.
 */
export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    try {
      await unwrap(api.GET('/api/v1/auth/me'));
      throw redirect({ to: '/me' });
    } catch (err) {
      if (err instanceof AuthRequiredError) {
        throw redirect({ to: '/sign-in' });
      }
      throw err;
    }
  },
  component: () => null,
});
